export default {
  computed: {
    interval() {
      return this.getSingleVar.step ? this.getSingleVar.step : 1;
    },
    getMin() {
      return !this.$_.isEmpty(this.validation)
        ? Number(this.validation.min)
        : 0;
    },
    getMax() {
      return !this.$_.isEmpty(this.validation)
        ? Number(this.validation.max)
        : 100;
    },
  },
  methods: {

  },
};
